
const productAdds = document.querySelectorAll('.Product_Slider__Item_Add .Product_Slider__Item_Add_Item')
productAdds.forEach((item) => {
  item.addEventListener('click', (e) => {     
    const productId = e.target.dataset.variantId
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
      items: [
        {
          quantity: 1,
          id: productId
        }
      ]
      })
    }).then(res => res.json())
      .then (res => {     
        if(res && res.items && res.items.length > 0) {
          const parent = e.target.closest('.Product_Slider__Item_Add')         
          const addedEl = parent.previousElementSibling
          addedEl.classList.remove('hidden')
          setTimeout(()=>{
            addedEl.classList.add('hidden')
          }, 2000)
        }else{
          const parent = e.target.closest('.Product_Slider__Item_Add');
          const addedEl = parent.previousElementSibling.previousElementSibling;
          addedEl.classList.remove('hidden')
          setTimeout(()=>{
            addedEl.classList.add('hidden')
          }, 2000)
        }
      })
      .catch(err => console.error(err))
  })
})

const addToCartMobile = document.querySelectorAll('.Product_Slider__Item_Add_Mobile')
addToCartMobile.forEach((item) => {
    item.addEventListener('click', (e) => {
    e.preventDefault()
    e.stopPropagation()
    const target = e.currentTarget
    if(!target.classList.contains('Product_Slider__Item_Add_Mobile--clicked')){
        target.classList.add('Product_Slider__Item_Add_Mobile--clicked')
    } else {
        target.classList.remove('Product_Slider__Item_Add_Mobile--clicked')
    }
    const addEl = target.closest('.product-card__variants').querySelector('.Product_Slider__Item_Add')
    const isShowing = addEl.classList.contains('Product_Slider__Item_Add--visible')
    if(isShowing){
        addEl.classList.remove('Product_Slider__Item_Add--visible')
    } else {
        addEl.classList.add('Product_Slider__Item_Add--visible')
    }
    })
})